import { ButtonGroup } from 'react-bootstrap'
import styled from 'styled-components'
import { $DCprimaryColor, $secondaryColor, colors } from '../styleGuide'

const Section = styled.div<{ noPadding?: boolean; isMobile?: boolean }>`
  width: 100%;
  height: auto;
  padding: ${(props) => (props.noPadding ? '0 8px' : ' 10px 20px')};
  &.fullheight {
    height: 100%;
  }
`
const SectionTitle = styled.div<{ color?: string }>`
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.color || colors.grayTextDark};
  margin-bottom: 15px;
  a {
    color: ${colors.grayTextDark} !important;
    text-decoration: none !important;
  }
`
const SectionContent = styled.div<{
  noPadding?: boolean
  isMobile?: boolean
  height?: string
  overflow?: string
}>`
  width: 100%;
  height: ${(props) => props.height || 'auto'};
  overflow: ${(props) => props.overflow || 'visible'};
  padding: ${(props) => (props.noPadding ? '0px 0px' : '10px 20px')};
  background: ${colors.white};
  border-radius: 5px;
  box-shadow: 0 7px 14px 0 rgba(65, 69, 88, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.07);
  min-height: 25px;
  &.fullheight {
    min-height: 100%;
    height: 100%;
  }
`
const SectionForm = styled.form<{ columnItems: string }>`
  display: grid;
  grid-template-columns: ${(props) => '1fr '.repeat(Number(props.columnItems))};
  grid-auto-columns: auto;
  grid-auto-rows: auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-bottom: 15px;
`
const SectionActions = styled.div`
  // right align items
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
`
const ActionIconSection = styled.div`
  display: inline-flex;
  border-radius: 5px;
  padding: 5px 15px;

  &:hover {
    background: ${colors.grayLighter};
    cursor: pointer;
  }
`

const ButtonsGroup = styled(ButtonGroup)``
const Link = styled.a<{ decoration: boolean }>`
  color: ${$DCprimaryColor};
  font-size: 14px;
  text-decoration: ${(props) => (props.decoration ? 'underline' : 'none')};
  cursor: pointer;
  width: fit-content;
  font-weight: 400;
  &:hover {
    color: ${colors.primaryActive};
    text-decoration: ${(props) => (props.decoration ? 'none' : 'underline')};
  }
`
export {
  Section,
  SectionTitle,
  SectionContent,
  SectionForm,
  SectionHeader,
  SectionActions,
  ActionIconSection,
  ButtonsGroup,
  Link,
}
